export const SAMPLE_CASE = 'SAMPLE_CASE';